import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MatBadge } from '@angular/material/badge';
import { MatIcon } from '@angular/material/icon';
import { NotificationStore } from '../notification-store';

@Component({
  selector: 'upu-notification-button',
  imports: [MatIcon, MatBadge],
  host: {
    class: 'shrink-0 block',
  },
  template: `
    <button
      id="notification-button"
      type="button"
      class="icon-button size-9 overflow-visible"
      (click)="openPanel()"
    >
      <mat-icon
        class="text-[22px]"
        aria-hidden="false"
        [matBadge]="unreadCount() < 100 ? unreadCount() : '99+'"
        [matBadgeHidden]="unreadCount() === 0"
      >
        notifications
      </mat-icon>
    </button>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NotificationButton {
  private readonly notificationStore = inject(NotificationStore);

  protected readonly unreadCount = this.notificationStore.unreadCount.value;

  protected openPanel(): void {
    this.notificationStore.openPanel.set(true);
  }
}
